import { Box, Button, Flex, Text, Tooltip } from '@chakra-ui/react';
import { EditPencilIcon, FlagIcon, TrashIcon } from '../icons';
import { Link } from 'react-router-dom';
import { useDeleteGoal } from './api';
import { useQueryClient } from '@tanstack/react-query';
import { useToastHook } from '../appToast';
import { formatDate } from './helpers/GoalTable.utils';
import { getRole, UserRole } from '@devd-client/api';
import { Goal } from './types';

interface GoalsColumnCellProps {
  data: Goal;
}

export const GoalsColumnCell = ({ data }: GoalsColumnCellProps) => {
  const { mutate: deleteGoal, isLoading } = useDeleteGoal();
  const [newToast] = useToastHook();
  const queryClient = useQueryClient();

  const handleDeleteGoal = () => {
    deleteGoal(data?.id, {
      onSuccess: () => {
        newToast({
          message: 'Goal deleted successfully',
          status: 'success',
        });
        queryClient.invalidateQueries(['goalsData']);
      },
      onError: (error: any) => {
        newToast({
          message: error?.message || 'Failed to delete goal',
          status: 'error',
        });
      },
    });
  };

  return (
    <Flex direction={'column'} gap={'20px'} maxW={'264px'} overflow="hidden">
      <Flex align={'center'} gap={2} width="100%" overflow="hidden">
        <FlagIcon />
        <Text
          color="text.gray.300"
          fontWeight={'medium'}
          width="fit-content"
          isTruncated
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {data?.title}
        </Text>
        {(getRole() === UserRole.EMPLOYER_ADMIN ||
          getRole() === UserRole.SUPPORT) && (
          <Tooltip label="Edit Goal" placement="right" hasArrow>
            <Box p="2px">
              <Link to={`/goal/edit/${data?.id}`}>
                <EditPencilIcon />
              </Link>
            </Box>
          </Tooltip>
        )}
      </Flex>
      <Box
        bg={'#F7F7F8'}
        p={'4px'}
        rounded={'4px'}
        border={'1px solid'}
        borderColor={'text.tertiary'}
        color={'text.secondary2'}
        fontWeight={'medium'}
        maxW={'fit-content'}
      >
        {data?.timeframe}
      </Box>
      <Flex justify={'space-between'} align={'center'}>
        <Text color={'text.secondary2'}>
          {data?.startDate ? formatDate(data?.startDate) : '-'} -{' '}
          {data?.endDate ? formatDate(data?.endDate) : '-'}
        </Text>
        {(getRole() === UserRole.EMPLOYER_ADMIN ||
          getRole() === UserRole.SUPPORT) && (
          <Tooltip label="Delete Goal" placement="right" hasArrow>
            <Button
              variant={'ghost'}
              onClick={handleDeleteGoal}
              isLoading={isLoading}
              p="0"
            >
              <TrashIcon />
            </Button>
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
};
